import React, { useEffect, useRef } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import "../pages/CreateListing.css";


export default function ABLocationAutocomplete({ value, onSelect, placeholder = "e.g. Miami, FL", types = ['(cities)'], inputClassName = "cl-text-input" }) {
  const inputRef = useRef(null);
  const placesLib = useMapsLibrary('places');

  useEffect(() => {
    if (!placesLib || !window.google || !inputRef.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types,
      componentRestrictions: { country: 'us' },
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place || !place.formatted_address) return;

      const lat = place.geometry?.location?.lat ? place.geometry.location.lat() : null;
      const lng = place.geometry?.location?.lng ? place.geometry.location.lng() : null;

      onSelect({
        formattedAddress: place.formatted_address,
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
        place,
      });
    });
  }, [placesLib, onSelect, types]);

  return (
    <input
      ref={inputRef}
      defaultValue={value}
      className={inputClassName}
      placeholder={placeholder}
    />
  );
}
